module.exports = __webpack_public_path__ + "static/media/BaiJamjuree-Bold.c553df6a.ttf";